import { IWebWorkerHttpProvider, IHttpConfig } from "../sessions/models";
import axios from "axios";

export class WebWorkerHttpProvider implements IWebWorkerHttpProvider {
  public httpConfig: IHttpConfig = null;

  constructor() {
    this.httpConfig = null;
  }

  private ensureHttpConfig(): void {
    if (!this.httpConfig) {
      throw new Error("Missing http config!");
    }
    if (!this.httpConfig.headers.Authorization) {
      throw new Error("Missing authorization token!");
    }
  }

  public get<R>(url: string, params?: any, options: { skipConfigParams: boolean } = { skipConfigParams: false }): Promise<R> {
    this.ensureHttpConfig();
    return axios
      .get(url, { ...this.httpConfig, params: options.skipConfigParams ? { ...params } : { ...this.httpConfig.params, ...params } })
      .then((response) => response.data);
  }

  public post<R>(url: string, body?: unknown, params?: any, options: { skipConfigParams: boolean } = { skipConfigParams: false }): Promise<R> {
    this.ensureHttpConfig();
    return axios
      .post(url, body, { ...this.httpConfig, params: options.skipConfigParams ? { ...params } : { ...this.httpConfig.params, ...params } })
      .then((response) => response.data);
  }

  public put<R>(url: string, body?: unknown, params?: any): Promise<R> {
    this.ensureHttpConfig();
    return axios.put(url, body, { ...this.httpConfig, params: { ...this.httpConfig.params, ...params } }).then((response) => response.data);
  }

  public patch<R>(url: string, body?: unknown, params?: any): Promise<R> {
    this.ensureHttpConfig();
    return axios.patch(url, body, { ...this.httpConfig, params: { ...this.httpConfig.params, ...params } }).then((response) => response.data);
  }

  public delete<R>(url: string): Promise<R> {
    this.ensureHttpConfig();
    return axios.delete(url, this.httpConfig).then((response) => response.data);
  }
}

export const http = new WebWorkerHttpProvider();
